<template>
  <div class="container-fluid py-4">
    <div class="card mb-4">
      <div class="card-body text-center mb-3">
        <img src="/forbidden.jpg" class="no-access-img" />
        <h2>403 Forbidden</h2>
        <p>You do not have permission to access this page.</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "noaccess",
};
</script>
<style scoped>
.no-access-img {
  width: 30vw;
  height: 30vw;
  max-width: 500px;
  max-height: 500px;
  min-width: 200px;
  min-height: 200px;
  object-fit: contain;
}
</style>
